<template>
  <div>
    {{value}}
  </div>
</template>
<script>

export default {
  name: "MixinValueGrid",

  async created()  {
    await this.loadNotificationData();
  },

  mounted(){
  },

  methods: {
    async loadNotificationData(){
      this.value = this.model[this.prop];
    },
  },

  props: ["rowIndex", "prop", "model", "column"],

  data: () => ({
    notificationIcon: "",
    notificationIconColor: "",
    value: null
  })

};
</script>
